export const CircularProgress = 'atlantis-circular-progress';
export const StatusOverviewBarItem = 'atlantis-status-overview-bar-item';
